import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import ManuallyProvideCustomColor from './ManuallyProvideCustomColor';
import ClientProvider from './client';
export default createDemo(import.meta.url, ManuallyProvideCustomColor, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/customization/palette/demos/manually-provide-custom-color/ManuallyProvideCustomColor.tsx",
    "fileName": "ManuallyProvideCustomColor.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { createTheme, ThemeProvider } from '@mui/material/styles';\nimport Button from '@mui/material/Button';\nimport Box from '@mui/material/Box';\nimport Stack from '@mui/material/Stack';\nimport Typography from '@mui/material/Typography';\n\n// Augment the palette to include an ochre color\ndeclare module '@mui/material/styles' {\n  interface Palette {\n    ochre: Palette['primary'];\n  }\n\n  interface PaletteOptions {\n    ochre?: PaletteOptions['primary'];\n  }\n}\n\n// Update the Button's color options to include an ochre option\ndeclare module '@mui/material/Button' {\n  interface ButtonPropsColorOverrides {\n    ochre: true;\n  }\n}\n\nconst theme = createTheme({\n  palette: {\n    ochre: {\n      main: '#E3D026',\n      light: '#E9DB5D',\n      dark: '#A29415',\n      contrastText: '#242105',\n    },\n  },\n});\n\nexport default function ManuallyProvideCustomColor() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 2,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <ThemeProvider theme={theme}>\n      <Stack sx={{ gap: 2, alignItems: 'center' }}>\n        <Button variant=\"contained\" color=\"ochre\">\n          Ochre\n        </Button>\n        <Stack direction=\"row\" sx={{ gap: 1 }}>\n          <Stack sx={{ alignItems: 'center' }}>\n            <Typography variant=\"body2\">light</Typography>\n            <Box sx={{ bgcolor: 'ochre.light', width: 40, height: 20 }} />\n          </Stack>\n          <Stack sx={{ alignItems: 'center' }}>\n            <Typography variant=\"body2\">main</Typography>\n            <Box sx={{ bgcolor: 'ochre.main', width: 40, height: 20 }} />\n          </Stack>\n          <Stack sx={{ alignItems: 'center' }}>\n            <Typography variant=\"body2\">dark</Typography>\n            <Box sx={{ bgcolor: 'ochre.dark', width: 40, height: 20 }} />\n          </Stack>\n        </Stack>\n      </Stack>\n    </ThemeProvider>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 60,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { createTheme, ThemeProvider } from '@mui/material/styles';\nimport Button from '@mui/material/Button';\nimport Box from '@mui/material/Box';\nimport Stack from '@mui/material/Stack';\nimport Typography from '@mui/material/Typography';\n\n// Augment the palette to include an ochre color\ndeclare module '@mui/material/styles' {\n  interface Palette {\n    ochre: Palette['primary'];\n  }\n\n  interface PaletteOptions {\n    ochre?: PaletteOptions['primary'];\n  }\n}\n\n// Update the Button's color options to include an ochre option\ndeclare module '@mui/material/Button' {\n  interface ButtonPropsColorOverrides {\n    ochre: true;\n  }\n}\n\nconst theme = createTheme({\n  palette: {\n    ochre: {\n      main: '#E3D026',\n      light: '#E9DB5D',\n      dark: '#A29415',\n      contrastText: '#242105',\n    },\n  },\n});\n\nexport default function ManuallyProvideCustomColor() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 2
        },
        "    <ThemeProvider theme={theme}>\n      <Stack sx={{ gap: 2, alignItems: 'center' }}>\n        <Button variant=\"contained\" color=\"ochre\">\n          Ochre\n        </Button>\n        <Stack direction=\"row\" sx={{ gap: 1 }}>\n          <Stack sx={{ alignItems: 'center' }}>\n            <Typography variant=\"body2\">light</Typography>\n            <Box sx={{ bgcolor: 'ochre.light', width: 40, height: 20 }} />\n          </Stack>\n          <Stack sx={{ alignItems: 'center' }}>\n            <Typography variant=\"body2\">main</Typography>\n            <Box sx={{ bgcolor: 'ochre.main', width: 40, height: 20 }} />\n          </Stack>\n          <Stack sx={{ alignItems: 'center' }}>\n            <Typography variant=\"body2\">dark</Typography>\n            <Box sx={{ bgcolor: 'ochre.dark', width: 40, height: 20 }} />\n          </Stack>\n        </Stack>\n      </Stack>\n    </ThemeProvider>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "totalLines": 60,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/styles",
      "@mui/material/Button",
      "@mui/material/Box",
      "@mui/material/Stack",
      "@mui/material/Typography"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
